import type { PropsWithChildren } from 'react';

import styled from 'styled-components';

import { CardItemOverflowMenu, PaymentCardItem } from 'src/app/components/PageSections/CardItemOverflowMenuWrapper';
import type { MenuActions } from 'src/app/components/PageSections/CardItemOverflowMenuWrapper';

interface AccountPageItemProps
  extends PropsWithChildren<{
    menuActions: MenuActions;
  }> {}

const StyledCardItemOverflowMenu = styled(CardItemOverflowMenu)`
  width: 2rem !important;
`;

export const AccountPageItem = ({ menuActions, children }: AccountPageItemProps) => {
  return (
    <PaymentCardItem>
      {children}
      <StyledCardItemOverflowMenu menuActions={menuActions} />
    </PaymentCardItem>
  );
};
